import { BOTTOM_SHEET } from '@/common/constants/ConstCode';
import store from '@/store';
import { isIPad, isIPhone } from '@/common/utils/module/IsMobileSupport';
export const businessGuard = async next => {
  // if (isIPad() || isIPhone()) {
  //   const bottomSheet = store.getters['layout/getBottomSheet'];
  //   if (bottomSheet === BOTTOM_SHEET.BUSINESS_SEARCH) {
  //     store.commit('layout/setBottomSheet', BOTTOM_SHEET.BUSINESS);
  //     store.commit('business/initBusinessList');
  //     store.commit('business/searchText');
  //     store.commit('business/markerPin');
  //     await store.dispatch('business/getBusinessList', { isOneKM: true, isDonation: true, isEvent: true });
  //     store.commit('business/coordinateChange', true);
  //     next(false);
  //   } else {
  //     return true;
  //   }
  // }
};
